import { Button } from '@mui/material';

import { Iconify } from './iconify';

export const ButtonEdit = ({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) => (
  <Button
    variant="contained"
    startIcon={<Iconify icon="solar:pen-bold" />}
    onClick={onClick}
    disabled={disabled}
    sx={{
      bgcolor: 'primary.lighter',
      color: 'primary.dark',
      '&:hover': {
        bgcolor: 'primary.light',
      },
    }}
  >
    Edit
  </Button>
);
